import { useSelector } from "react-redux";

import { EXPENSE_CHECK_HISTORY } from "../../api/allApi_List";
import DialogBox from "../../components/UI/DialogBox";
import spin from "../../assets/icons/spin.png";
import { handleErrMessage } from "../../functions/handleErrMessage";
import MainPageLayout from "../../layout/MainPageLayout";
import useFetchData from "../../CustomHooks/useAxios/useFetchData";
import CheckExpenseHistory from "../../components/expense/all/CheckExpenseHistory";

const CheckExpenseHistoryPage = () => {
  const { isLoaded } = useFetchData(EXPENSE_CHECK_HISTORY);
  const data = useSelector((state) => state.data.data);
  const error = useSelector((state) => state.data.error);
  const errMsg = useSelector((state) => state.data.errMessage);
  const dataLength = isLoaded && !errMsg ? data.length : 0;

  return (
    <MainPageLayout
      headerConfig={{ title: "Check History" }}
      numberOfData={dataLength}
    >
      {isLoaded && !error ? (
        <CheckExpenseHistory />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(errMsg)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading..." animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default CheckExpenseHistoryPage;
